var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUnknown = function SvgUnknown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#A1A3A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38526 5.93278C7.38526 5.63364 7.64362 5.38526 7.96968 5.38526C8.29476 5.38526 8.55296 5.63377 8.55296 5.93278C8.55635 6.15507 8.52747 6.19852 8.18716 6.44691L8.16039 6.46644C7.38594 7.03156 7.11124 7.50234 7.15311 8.32328L7.15205 8.42076C7.15205 8.87398 7.51811 9.24004 7.96968 9.24004C8.42124 9.24004 8.78731 8.87398 8.78731 8.42241V8.28164C8.77652 8.05395 8.79194 8.02993 9.12429 7.78742L9.15119 7.76779C9.91824 7.20793 10.2009 6.73722 10.1881 5.92004C10.1882 4.72356 9.19123 3.75 7.96968 3.75C6.74572 3.75 5.75 4.72482 5.75 5.93278C5.75 6.38435 6.11607 6.75041 6.56763 6.75041C7.0192 6.75041 7.38526 6.38435 7.38526 5.93278Z",
    fill: "#A1A3A7"
  })));
};
export default SvgUnknown;